<template>
	<div style="position: relative;">
		<div class="flex-wrapper">
			<div>
                <select-item-from-api-provided-list
                    api="pimapi/products"
                    :columns="['name']"
                    list-label="Select Product"
                    @selection="handleProductSelected"
                >
                </select-item-from-api-provided-list>
            </div>
            <div>
                <button v-on:click="postProduct()" :class="{ disabled: !selectedProduct.id && !project }" class="btn btn-primary mr-1">Add Product</button>
            </div>
		</div>
	</div>
</template>

<style lang="css" scoped>
.flex-wrapper {
    display: flex;
    flex-direction: column;
}
</style>

<script type="text/javascript">
var base_url = window.location.protocol + "//" + window.location.host;
import Vue from "vue";
import VueEvents from "vue-events";
import axios from "axios";
import SelectItemFromApiProvidedList from '../generic/select-item-from-api-provided-list.vue';
Vue.use(VueEvents);
export default {
    name: "AddProjectProducts",
    props: ['project'],
    components: {
        "select-item-from-api-provided-list": SelectItemFromApiProvidedList
    },
    data() {
        return {
            selectedProduct: {},
            uiStates: {
                showLoading: true
            }
        };
    },
    methods: {
        handleProductSelected(item) {
            this.selectedProduct = item;
        },
        postProduct: function() {
            axios
                .post(
                    `${base_url}/pimapi/projects/${this.project}/products`,
                    { productIds: [this.selectedProduct.id] }
                )
                .then(
                    function(response) {
                        console.log(response.data);
                        window.location.reload();
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        this.$parent.alert.status = "alert-danger";
                        this.$parent.alert.message =
                            error.response.data.message;
                    }.bind(this)
                );
        }
    },
    mounted() {}
};
</script>
